import { useMemo } from "react";
import StoreCard from "./StoreCard";
import { partyGearStores } from "../../constants/partyGearStores";

const normalize = (v) => (v ?? "").trim().toLowerCase();

const PartyGearStoresList = ({ selectedCountry, selectedCity }) => {
    const filteredStores = useMemo(() => {
        const c = normalize(selectedCountry);
        const city = normalize(selectedCity); // "" means All Cities

        return partyGearStores.filter((s) => {
            const matchesCountry = !c || normalize(s.country) === c;
            const matchesCity = !city || normalize(s.city) === city;
            return matchesCountry && matchesCity;
        });
    }, [selectedCountry, selectedCity]);

    return (
        <div className="max-w-7xl mx-auto px-4">
            {filteredStores.length === 0 ? (
                <div className="text-center py-10 text-gray-600">
                    No stores found for {selectedCity || "All Cities"}, {selectedCountry}.
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {filteredStores.map((store, index) => (
                        <StoreCard key={`${store.name}-${index}`} store={store} />
                    ))}
                </div>
            )}

            <div className="text-center mt-12">
                <p className="text-sm text-gray-500">💖 Supporting queer businesses across Australia!</p>
                <p className="text-sm text-gray-500">If you know of any other great LGBTQ+ stores, please let us know!</p>
            </div>
        </div>
    );
};

export default PartyGearStoresList;
